import { createFileRoute } from "@tanstack/react-router";
import PricingPage from "@/pages/PricingPage";

const TITLE = "Tarifs Thiia — CRM sans abonnement, packs de crédits 29, 59, 99 €";
const DESC =
  "Payez seulement ce que vous utilisez : packs de crédits Thiia à 29, 59 ou 99 €, achat unique, sans abonnement ni engagement. Pensé pour les indépendants et petites structures.";

export const Route = createFileRoute("/pricing")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://thiia.app/pricing" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://thiia.app/pricing" }],
  }),
  component: PricingPage,
});
